export default "/images/6983f560e6a13f715ef0d9f0d3db9d78.avif";